import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/Layout/Header/Header';
import Footer from './components/Layout/Footer/Footer';
import AuthGuard from './components/Guards/GuardAuth';
import Home from './components/Sections/Home/Home';
import CreateForm from './components/Sections/CreateForm/CreateForm';
import GetForms from './components/Sections/GetForm/GetForms';
import CreateUser from './components/Sections/createUser/createUser';
import NotFound from './components/Layout/404/NotFound';
import Stats from './components/Sections/Stats/Stats';
import ChangePassword from './components/Sections/ChangePassword/ChangePassword';

const Router = () => (
    <BrowserRouter>
        <Header />
        <Routes>
            <Route
                path="/"
                element={
                    <AuthGuard>
                        <Home />
                    </AuthGuard>
                }
            />
            <Route
                path="/create-form"
                element={
                    <AuthGuard>
                        <CreateForm />
                    </AuthGuard>
                }
            />
            <Route
                path="/forms"
                element={
                    <AuthGuard>
                        <GetForms />
                    </AuthGuard>
                }
            />
            <Route
                path="/create-user"
                element={
                    <AuthGuard>
                        <CreateUser />
                    </AuthGuard>
                }
            />
            <Route
                path="/stats"
                element={
                    <AuthGuard>
                        <Stats />
                    </AuthGuard>
                }
            />
            <Route
                path="/change-password"
                element={
                    <AuthGuard>
                        <ChangePassword />
                    </AuthGuard>
                }
            />
            <Route path="*" element={<NotFound />} />
        </Routes>

        <Footer />
    </BrowserRouter>
);

export default Router;
